<template>
  <div
    class="flex flex-col justify-center items-center fixed z-50 inset-0 bg-opacity-25 bg-black"
    @click.self="close"
  >
    <div class="form-card relative">
      <button
        class="system-button absolute right-4 top-4"
        @click.prevent="close"
      >
        <close-icon class="w-8 fill-current" />
      </button>

      <button
        v-if="canQuoteWithEnvia && !quoteWithEnvia"
        class="secondary-button mt-2"
        @click.prevent="quoteWithEnvia = true"
      >
        Cotizar con envía.com
      </button>

      <button
        v-else-if="canQuoteWithEnvia && quoteWithEnvia"
        class="cancel-button mt-2"
        @click.prevent="
          quoteWithEnvia = false;
          cleanQuoteForm();
        "
      >
        Cancelar
      </button>

      <form v-if="quoteWithEnvia" @submit.prevent="getShippingRates">
        <div v-if="order.client.preferred_carrier_id" class="text-sm mt-2">
          <p class="font-medium">Paquetería preferida</p>
          <p>
            {{
              carriers.filter(
                (carrier) => carrier.id === order.client.preferred_carrier_id
              )[0].display_name
            }}
          </p>
        </div>

        <div class="flex flex-col w-full mt-2">
          <label for="carrier">Paquetería</label>
          <custom-select
            class=""
            id="carrier"
            v-model="form.carrier"
            :options="getCarrierOptions()"
          />
          <validation-errors :errors="errorFor('carrier')"></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-2">
          <label for="weight">Peso (kg)</label>
          <input
            id="weight"
            type="number"
            :min="0"
            v-model="form.weight"
            step="any"
          />
          <validation-errors :errors="errorFor('weight')"></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-2">
          <label for="length">Longitud (cm)</label>
          <input
            id="length"
            type="number"
            :min="0"
            v-model="form.length"
            step="any"
          />
          <validation-errors :errors="errorFor('length')"></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-2">
          <label for="width">Ancho (cm)</label>
          <input
            id="width"
            type="number"
            :min="0"
            v-model="form.width"
            step="any"
          />
          <validation-errors :errors="errorFor('width')"></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-2">
          <label for="height">Altura (cm)</label>
          <input
            id="height"
            type="number"
            :min="0"
            v-model="form.height"
            step="any"
          />
          <validation-errors :errors="errorFor('height')"></validation-errors>
        </div>

        <primary-button type="submit" class="mt-6 mx-0" :loading="loadingQuote"
          >Cotizar
        </primary-button>
      </form>

      <p v-if="shippingRates && shippingRates.length === 0">
        No se encontraron resultados
      </p>

      <div
        class="w-full card border border-gray-200 mt-4 cursor-pointer"
        :class="[{ 'selected-border': index === selectedShippingRate }]"
        v-for="(rate, index) in shippingRates"
        :key="index"
      >
        <p>{{ rate.carrierDescription }}</p>

        <p class="text-sm">{{ rate.deliveryEstimate }}</p>
        <p class="text-sm font-medium">
          {{ integerToCurrency(rate.totalPrice) }}
        </p>

        <button
          class="secondary-button mt-2"
          @click.prevent="shipping_price = rate.totalPrice"
        >
          Seleccionar
        </button>
      </div>

      <form @submit.prevent="save">
        <div class="flex flex-col w-full mt-4">
          <label for="shipping_price">Precio</label>
          <input
            id="shipping_price"
            type="number"
            v-model="shipping_price"
            step="any"
          />
          <validation-errors
            :errors="errorFor('shipping_price')"
          ></validation-errors>
        </div>

        <primary-button type="submit" class="mt-6 mx-0"
          >Guardar
        </primary-button>
      </form>
    </div>
  </div>
</template>

<script>
import validationErrors from "@/mixins/validationErrors";
import api from "@/api";
import { is422 } from "@/utils/response";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Shipping Price Modal",

  data() {
    return {
      shipping_price: null,
      form: {
        carrier: "",
        weight: null,
        length: 36,
        width: 36,
        height: 36,
      },
      quoteWithEnvia: false,
      loadingQuote: false,
      shippingRates: null,
      selectedShippingRate: null,
    };
  },

  props: {
    order: Object,
    carriers: Array,
  },

  computed: {
    canQuoteWithEnvia() {
      const branch = this.order.address.branches.filter(
        (br) => br.id === this.order.branch_id
      )[0];

      return branch.can_ship;
    },
  },

  mixins: [validationErrors],

  created() {
    this.shipping_price = this.order.shippingPrice;
  },

  methods: {
    integerToCurrency,

    close() {
      this.$emit("close");
    },

    cleanQuoteForm() {
      this.form = {
        carrier: "",
        weight: null,
        length: null,
        width: null,
        height: null,
      };

      this.shippingRates = null;
    },

    getCarrierOptions() {
      const options = [{ value: null, label: "Seleccionar", disabled: false }];

      this.carriers.forEach((carrier) => {
        options.push({
          value: carrier.name,
          label: carrier.display_name,
        });
      });

      return options;
    },

    save() {
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      this.createShippingPrice();
    },

    validateForm() {
      this.errors = {};

      if (this.shipping_price == null) {
        this.errors["shipping_price"] = ["Campo requerido"];
      }

      return Object.keys(this.errors).length === 0;
    },

    async createShippingPrice() {
      this.$emit("confirm", this.shipping_price);
    },

    validateQuoteForm() {
      this.errors = {};

      if (!this.form.carrier) {
        this.errors["carrier"] = ["Campo requerido"];
      }

      if (!this.form.weight) {
        this.errors["weight"] = ["Campo requerido"];
      }

      if (!this.form.length) {
        this.errors["length"] = ["Campo requerido"];
      }

      if (!this.form.width) {
        this.errors["width"] = ["Campo requerido"];
      }

      if (!this.form.height) {
        this.errors["height"] = ["Campo requerido"];
      }

      return Object.keys(this.errors).length === 0;
    },

    async getShippingRates() {
      if (!this.validateQuoteForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      this.loadingQuote = true;

      try {
        this.shippingRates = await api.orders.getShippingRates(
          this.order.id,
          this.form
        );

        this.shippingRates.forEach(
          (rate) => (rate.totalPrice = (rate.totalPrice * 1.1).toFixed(2))
        );
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingQuote = false;
    },
  },
};
</script>